module.exports = __webpack_public_path__ + "media/images/axencia_estatal_investigacion-7e0af51c86abdea55948254835a39821.jpg";